import z from "zod";
import { ZodDateString } from "../../zod-types/zod-date-string";

export const getCrewDefinitionTicketAssignmentsQuerySchema = z.object({
	startDate: ZodDateString,
	endDate: ZodDateString,
});

export type GetCrewDefinitionTicketAssignmentsQuerySchema = z.infer<
	typeof getCrewDefinitionTicketAssignmentsQuerySchema
>;
